import { createWidgetMixin } from 'vue-instantsearch';
import { connectHits } from 'instantsearch.js/es/connectors';

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisConfigure,
} from 'vue-instantsearch';

export default {
    mixins: [
        createWidgetMixin({ connector: connectHits })
    ],
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisConfigure
    },
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-advertisements/components/advertisements-custom-hit/advertisements-custom-hit.js